module.exports = __webpack_public_path__ + "img/bg_avatar_male_87.f863e08a.png";